import {
  Component,
  EventEmitter,
  Input,
  Output,
  SimpleChanges,
} from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { NgSelectModule } from '@ng-select/ng-select';
import { NgxMaskDirective } from 'ngx-mask';
import Swal from 'sweetalert2';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatOptionModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import {
  OwlDateTimeModule,
  OwlNativeDateTimeModule,
} from '@danielmoncada/angular-datetime-picker';
import { BenefInfoComponent } from '@shared/components/benef-info/benef-info.component';
import { FileUploadComponent } from '@shared/components/file-upload/file-upload.component';
import { ScrollSearchMedocPrestaComponent } from '@shared/components/scroll-search-medoc-presta/scroll-search-medoc-presta.component';
import { PrestationInfoComponent } from '@shared/components/prestation-info/prestation-info.component';
import { SearchMdicamentProComponent } from '@shared/components/search-mdicament-pro/search-mdicament-pro.component';
import { SearchExamenLaboComponent } from '@shared/components/search-examen-labo/search-examen-labo.component';
import { RestClientService } from '@core/service/rest-client.service';
import { UtilitiesService } from '@core/service/utilities.service';
import { AuthService } from '@core';
import { ScrollSearchActeComponent } from '@shared/components/scroll-search-acte/scroll-search-acte.component';
import { SearchFormComponent } from '@shared/components/search-form/search-form.component';
import { SearchFormFullComponent } from '@shared/components/search-form-full/search-form-full.component';
import { MatTabGroup, MatTabsModule } from '@angular/material/tabs';
import { MatPaginatorModule, PageEvent } from '@angular/material/paginator';
import { DetailHospitComponent } from './detail-hospit/detail-hospit.component';
import { IntegerFormatPipe } from '@shared/pipe/integer-format.pipe';
import { PrescriptionHubComponent } from '@shared/components/prescription-hub/prescription-hub.component';

@Component({
  selector: 'app-histo-hospitalisation',
  imports: [
    CommonModule,
    NgSelectModule,
    FormsModule,
    BenefInfoComponent,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatOptionModule,
    FormsModule,
    ReactiveFormsModule,
    MatIconModule,
    FileUploadComponent,
    MatCheckboxModule,
    MatRadioModule,
    MatDatepickerModule,
    MatButtonModule,
    OwlDateTimeModule,
    OwlNativeDateTimeModule,
    MatSlideToggleModule,
    ScrollSearchMedocPrestaComponent,
    BenefInfoComponent,
    PrestationInfoComponent,
    SearchMdicamentProComponent,
    SearchExamenLaboComponent,
    ScrollSearchActeComponent,
    SearchFormComponent,
    SearchFormFullComponent,
    MatTabGroup,
    MatTabsModule,
    DetailHospitComponent,
    IntegerFormatPipe,
    MatPaginatorModule,
    PrescriptionHubComponent,
  ],
  templateUrl: './histo-hospitalisation.component.html',
  styleUrl: './histo-hospitalisation.component.scss',
})
export class HistoHospitalisationComponent {
  selectedTab = 'tab1';
  @Output() onSendBenefItem = new EventEmitter<any>();
  @Output() onClosePrescriptionMedocModal = new EventEmitter<any>();
  @Output() onGoToTab = new EventEmitter<any>();
  @Input() matricule: any;
  @Input() itemBeneficiare: any;
  cancelItemSelected = false;
  @Input() refreshTriggerOrdonnance!: boolean;
  @Output() showExploitationHospitForm = new EventEmitter<any>();
  @Output() onNouvelleDemandeClick = new EventEmitter<void>();

  current_medicament_id: any = '';
  reload = false;
  produit: string = '';
  clearText = false;
  posologie: string = '';
  frequence: string = '';
  renouvellement: string = '';
  quantite: number = 1;
  items: any = [];
  selectedItem: any = {};
  dossierActif: any = {};
  prestationActive: any = {};
  itemsElement: any = [];

  isLoading: boolean | undefined;
  input_value: any;
  input_option = 'MAT';
  searchPlaceHolder = 'Entrez numéro matricule';

  user: any = {};
  isConsultationSuccess = false;
  itemConsultation: any = {};
  itemToAdd: any = {};
  itemToSave: any = {};
  itemsModePrescription = [
    { code: 'produit', libelle: 'Produit' },
    { code: 'molecule', libelle: 'Molécule' },
  ];
  // model: NgbDateStruct | undefined;
  fileName1: any;
  currentFile: any;
  selectedDemandeHospit: any = {};
  itemsAffection: any = [];
  itemsPrescription: any;
  selectedPrescription: any;
  beneficiaireAutOselect: any;
  itemsGarantie: any;
  garantie_id: any;
  itemsDemandeHospitalisation: any = [];

  // Filtres
  showFilters = false;
  filterMatricule = '';
  filterType = '';
  filterStatut = '';
  filterDateDebut = this.toDateInput(this.offsetDay(-3));
  filterDateFin = this.toDateInput(this.offsetDay(3));

  private offsetDay(n: number): Date {
    const d = new Date();
    d.setDate(d.getDate() + n);
    return d;
  }

  private toDateInput(d: Date): string {
    return d.toISOString().slice(0, 10); // yyyy-MM-dd
  }

  get itemsDemandeFiltered(): any[] {
    if (!this.itemsDemandeHospitalisation) return [];
    return this.itemsDemandeHospitalisation.filter((item: any) => {
      const matchType =
        !this.filterType ||
        item.type_hospitalisation_codification === this.filterType;
      const matchStatut =
        !this.filterStatut ||
        (this.filterStatut === 'rejected' && item.is_rejected) ||
        (this.filterStatut === 'validated' &&
          item.is_validated &&
          !item.is_rejected) ||
        (this.filterStatut === 'pending' &&
          !item.is_validated &&
          !item.is_rejected);
      return matchType && matchStatut;
    });
  }

  resetFilters() {
    this.filterMatricule = '';
    this.filterType = '';
    this.filterStatut = '';
    this.filterDateDebut = this.toDateInput(this.offsetDay(-3));
    this.filterDateFin = this.toDateInput(this.offsetDay(3));
  }

  // Modals
  showDetailModal = false;
  showActeModal = false;
  showProrogationModal = false;
  showFinHospitModal = false;
  showDecompteModal = false;
  showDecompteDetail = false;
  showHubModal = false;
  activeHubTab: 'prescrire' | 'suivi' = 'prescrire';
  itemsPrescriptionHospit: any[] = [];
  selectedPrescIds = new Set<number>();
  filterGarantiePresc: any = null;
  filterTodayOnly = false;
  itemsGarantiePresc: any[] = [];
  itemBeneficiaireHospit: any = null;
  isLoadingPrescriptions = false;
  selectedHospit: any = {};
  itemsActe: any = [];
  itemsPraticien: any = [];
  itemActe: any = {};
  itemProrogation: any = {};
  itemsSinistreHospit: any[] = [];
  isLoadingSinistres = false;
  totalMontantSinistres = 0;
  totalPartAssuranceSinistres = 0;
  totalPartPatientSinistres = 0;
  totalDepassementSinistres = 0;

  // Pagination
  index = 0;
  size = 10;
  totalItems = 0;

  constructor(
    private restClient: RestClientService,
    private authService: AuthService,
    private utilities: UtilitiesService,
  ) {
    this.user = this.authService.getCurrentUser();
    console.log('connected user: ', this.user);
    this.itemToAdd = {};
    this.itemToSave.mode_prescription = 'produit';
    // this.getItemsAffection()
    this.itemToSave.date_prescription = {
      year: new Date().getFullYear(),
      month: new Date().getMonth() + 1, // getMonth() returns 0-11
      day: new Date().getDate(),
    };
    this.beneficiaireAutOselect = this.authService.getActiveBeneficiaire();
    this.getItemsDemandeHospitalisationActive();
    this.getItemsAffection();
    this.getItemsActe();
  }

  getItemsAffection() {
    let request = {
      index: 0,
      size: 1000,
      data: {},
    };

    this.restClient.post('affection/getByCriteria', request).subscribe(
      (res: any) => {
        this.isLoading = false;
        if (res && !res['hasError'] && res['items']) {
          this.itemsAffection = res.items;
          console.log('this.itemsAffection: ', this.itemsAffection);
        } else {
          this.utilities.showSweetNotification(
            res['status']['message'],
            'error',
          );
          this.itemsAffection = [];
        }
      },
      (error) => {
        this.utilities.showSweetNotification(error, 'error');
        this.itemsAffection = [];
      },
    );
  }

  onSelectTab(tab: string) {
    this.selectedTab = tab;
  }

  onChangeInputMode() {
    this.input_value = '';
    this.searchPlaceHolder =
      this.input_option == 'MAT'
        ? 'Entrez numéro matricule'
        : 'Entrez numéro cnam';
  }

  getItemsDemandeHospitalisationActive() {
    this.selectedDemandeHospit = {};
    let request = {
      index: this.index,
      size: this.size,
      is_hospit: true,
      date_debut: this.filterDateDebut || null,
      date_fin: this.filterDateFin || null,
      data: {
        prestataire_id: this.user.prestataire_id,
        matricule: this.filterMatricule || null,
      },
    };

    this.restClient
      .post('prescriptionActe/getByCriteria', request)
      .subscribe({
        next: (res: any) => {
          this.isLoading = false;
          if (res && !res['hasError'] && res['items']) {
            this.itemsDemandeHospitalisation = res.items;
            this.totalItems = res['count'] ?? res.items.length;
            this.itemsDemandeHospitalisation.forEach((ip: any) => { ip.is_active = false; });
          } else {
            this.utilities.showSweetNotification(res['status']['message'], 'error');
            this.itemsDemandeHospitalisation = [];
            this.totalItems = 0;
          }
        },
        error: (error) => {
          this.utilities.showSweetNotification(error, 'error');
          this.itemsDemandeHospitalisation = [];
          this.totalItems = 0;
        },
      });
  }

  uploadFile(event: any) {
    const reader = new FileReader();
    if (event.target.files && event.target.files.length) {
      const file = event.target.files[0];
      const fileName = file.name.split('.')[0];
      const Tabextension = file.name.split('.');
      const extension = Tabextension[Tabextension.length - 1];

      console.info('fileName', fileName);
      console.info('extension', extension);
      this.fileName1 = fileName + '.' + extension;
      reader.onload = (readerEvent) => {
        const data = (readerEvent.target as any).result;
        // this.imageDisplay = data;
        const fileBase64 = data.split(',')[1];
        this.currentFile = {
          fileBase64: fileBase64,
          fileName: fileName,
          extension: extension,
          typeDocument: 'custom type',
        };
      };
    }

    reader.readAsDataURL(event.target.files[0]);
  }

  onGetDossiers() {}

  generateUniqueString() {
    // Get current timestamp in milliseconds
    var timestamp = new Date().getTime();

    // Generate a random number
    var randomNumber = Math.floor(Math.random() * 1000000); // Adjust range as needed

    // Concatenate timestamp and random number
    var uniqueString = timestamp.toString() + randomNumber.toString();

    return uniqueString;
  }

  onSelectRow(item: any): void {
    // if (this.isExpired(item.date_expiration)) return;
    this.selectedDemandeHospit = { ...item };
    if (item.is_expired) return;

    this.itemsDemandeHospitalisation.forEach((p: any) => (p.is_active = false));
    item.is_active = true;
    // this.showExploitationHospitForm.emit(item)
  }

  isExpired(expirationDate: string | Date): boolean {
    if (!expirationDate) return false; // Handle cases with no expiration date

    const expDate = new Date(expirationDate);
    const today = new Date();

    // Compare dates (ignoring time)
    return expDate.setHours(0, 0, 0, 0) > today.setHours(0, 0, 0, 0);
  }

  getItemsActe() {
    let request = {
      index: 0,
      size: 1000,
      data: { prestataire_id: this.user.prestataire_id },
    };
    this.restClient.post('acte/getByCriteria', request).subscribe({
      next: (res: any) => {
        if (res && !res['hasError'] && res['items']) {
          this.itemsActe = res.items.filter((it: any) => it.is_eligible);
        } else {
          this.itemsActe = [];
        }
      },
      error: () => { this.itemsActe = []; },
    });
  }

  getItemsPraticien() {
    let request = {
      index: 0,
      size: 1000,
      data: { acte_id: this.itemActe.acte_id },
    };
    this.restClient.post('praticien/searchByPrestataire', request).subscribe({
      next: (res: any) => {
        if (res && !res['hasError'] && res['items']) {
          this.itemsPraticien = res.items.map((ip: any) => ({
            ...ip,
            full_name: `${ip.nom} ${ip.prenom} (${ip.specialite_libelle})`,
          }));
        } else {
          this.itemsPraticien = [];
        }
      },
      error: () => { this.itemsPraticien = []; },
    });
  }

  onSelectActeHospit() {
    const acte = this.itemsActe.find(
      (a: any) => a.id === this.itemActe.acte_id,
    );
    if (acte) {
      this.itemActe.montant = acte.tarif || acte.montant || 0;
      const taux = this.selectedHospit?.taux_applicable || 0;
      this.itemActe.part_assurance = Math.round(
        (taux / 100) * this.itemActe.montant,
      );
      this.itemActe.part_patient =
        this.itemActe.montant - this.itemActe.part_assurance;
    }
    this.getItemsPraticien();
  }

  openDetailModal(item: any) {
    this.selectedHospit = { ...item };
    this.showDetailModal = true;
    document.body.style.overflow = 'hidden';
  }

  closeDetailModal() {
    this.showDetailModal = false;
    document.body.style.overflow = '';
  }

  openHubModal(item: any, tab: 'prescrire' | 'suivi' = 'prescrire') {
    this.selectedHospit = { ...item };
    this.activeHubTab = tab;
    this.showHubModal = true;
    document.body.style.overflow = 'hidden';
    if (tab === 'suivi') { this.loadGarantiesPresc(); this.loadBeneficiaireHospit(); this.loadPrescriptionsHospit(); }
  }

  closeHubModal() {
    this.showHubModal = false;
    document.body.style.overflow = '';
  }

  switchHubTab(tab: 'prescrire' | 'suivi') {
    this.activeHubTab = tab;
    if (tab === 'suivi') { this.loadGarantiesPresc(); this.loadBeneficiaireHospit(); this.loadPrescriptionsHospit(); }
  }

  loadBeneficiaireHospit() {
    const matricule = this.selectedHospit.matricule;
    if (!matricule) return;
    this.restClient.post('beneficiaire/search', {
      is_required_dossier: false,
      filiale_id: this.user.filiale_id,
      user_id: this.user.id,
      data: { matricule },
    }).subscribe({
      next: (res: any) => {
        if (res && !res['hasError'] && res['item']) {
          this.itemBeneficiaireHospit = res['item'];
        }
      },
    });
  }

  loadPrescriptionsHospit() {
    this.isLoadingPrescriptions = true;
    this.selectedPrescIds.clear();
    this.selectedPrescIds = new Set(this.selectedPrescIds);
    const data: any = { hospit_id: this.selectedHospit.id };
    if (this.filterGarantiePresc) data['garantie_id'] = this.filterGarantiePresc;
    this.restClient.post('prescriptionActe/getByCriteria', {
      user_id: this.user.id,
      filiale_id: this.user.filiale_id,
      index: 0, size: 1000,
      is_hospit_mode: true,
      data,
    }).subscribe({
      next: (res: any) => {
        this.isLoadingPrescriptions = false;
        const taux = parseFloat(this.itemBeneficiaireHospit?.taux_applicable ?? this.selectedHospit.taux_applicable) || 0;
        this.itemsPrescriptionHospit = (res?.['items'] ?? []).map((p: any) => {
          const prixRef = p.prix_systeme || p.prix_unitaire || 0;
          const qte = p.quantite || 1;
          const montant = prixRef * qte;
          const partAssurance = p.is_exclu ? 0 : (taux / 100) * montant;
          return {
            ...p,
            _prix_unitaire: prixRef,
            _quantite: qte,
            _montant: montant,
            _part_assurance: partAssurance,
            _part_patient: montant - partAssurance,
          };
        });
      },
      error: () => { this.isLoadingPrescriptions = false; this.itemsPrescriptionHospit = []; },
    });
  }

  onFilterGarantieChange() {
    this.loadPrescriptionsHospit();
  }

  private _calcPrescItem(p: any) {
    const prix = parseFloat(p._prix_unitaire) || 0;
    const qte = parseFloat(p._quantite) || 0;
    const prixSys = parseFloat(p.prix_systeme) || parseFloat(p.prix_unitaire) || prix;
    const taux = parseFloat(this.itemBeneficiaireHospit?.taux_applicable ?? this.selectedHospit.taux_applicable) || 0;
    p._montant = prix * qte;

    if (p.is_exclu) {
      p._part_assurance = 0;
      p._part_patient = p._montant;
      return;
    }

    const prixMax = prixSys * 1.1;
    if (prixSys > 0 && prix > prixMax) {
      const base = prixMax * qte;
      const depassement = (prix - prixMax) * qte;
      p._part_assurance = (taux / 100) * base;
      p._part_patient = ((100 - taux) / 100) * base + depassement;
    } else {
      p._part_assurance = (taux / 100) * p._montant;
      p._part_patient = ((100 - taux) / 100) * p._montant;
    }
  }

  onPrescPrixChange(p: any) { this._calcPrescItem(p); }
  onPrescQteChange(p: any) { this._calcPrescItem(p); }

  isPrescSelectable(p: any): boolean {
    if (p.is_executed || p.is_factured) return false;
    return true;
  }

  get prescriptionsFiltered(): any[] {
    if (!this.filterTodayOnly) return this.itemsPrescriptionHospit;
    const today = new Date().toISOString().slice(0, 10);
    return this.itemsPrescriptionHospit.filter(p => {
      const d = (p.updated_at || p.created_at || '').slice(0, 10);
      return d === today;
    });
  }

  get allPrescSelectables() {
    return this.prescriptionsFiltered.filter(p => this.isPrescSelectable(p));
  }

  private readonly GARANTIE_FILTER_CODES = new Set(['BIO', 'HOS', 'IMA', 'PHARMA', 'TRA', 'AUX']);

  loadGarantiesPresc() {
    if (this.itemsGarantiePresc.length) return;
    const centreActivites = new Set([
      ...(this.user.activite_utilisateur ?? []),
      ...(this.user.activite_utilisateur_autre ?? []),
    ].map((a: any) => a?.codification?.trim().toUpperCase()));

    this.restClient.post('garantie/getByCriteria', { index: 0, size: 1000, data: {} }).subscribe({
      next: (res: any) => {
        if (res && !res['hasError']) {
          this.itemsGarantiePresc = (res['items'] ?? []).filter((g: any) =>
            this.GARANTIE_FILTER_CODES.has(g.codification) &&
            centreActivites.has(g.codification)
          );
        }
      },
    });
  }

  get allPrescSelected() {
    const sel = this.allPrescSelectables;
    return sel.length > 0 && sel.every(p => this.selectedPrescIds.has(p.id));
  }

  toggleAllPresc() {
    const sel = this.allPrescSelectables;
    if (this.allPrescSelected) {
      sel.forEach(p => this.selectedPrescIds.delete(p.id));
    } else {
      sel.forEach(p => this.selectedPrescIds.add(p.id));
    }
    this.selectedPrescIds = new Set(this.selectedPrescIds);
  }

  togglePresc(p: any) {
    if (!this.isPrescSelectable(p)) return;
    if (this.selectedPrescIds.has(p.id)) {
      this.selectedPrescIds.delete(p.id);
    } else {
      this.selectedPrescIds.add(p.id);
    }
    this.selectedPrescIds = new Set(this.selectedPrescIds);
  }

  executerSelection() {
    const prescs = this.itemsPrescriptionHospit.filter(p => this.selectedPrescIds.has(p.id));
    if (!prescs.length) return;

    const datas = prescs.map(p => {
      const montant = parseFloat(p._montant) || 0;
      const partAssurance = parseFloat(p._part_assurance) || 0;
      return {
        prescription_acte_id: p.id,
        acte_id: p.acte_id,
        medicament_id: p.medicament_id,
        libelle: p.libelle || p.acte_libelle || p.medicament_libelle,
        quantite: parseFloat(p._quantite) || 1,
        prix_unitaire: parseFloat(p._prix_unitaire) || 0,
        montant, part_assurance: partAssurance, part_patient: montant - partAssurance,
        beneficiaire_id: this.selectedHospit.beneficiaire_id,
        matricule: this.selectedHospit.matricule,
        prestataire_id: this.user.prestataire_id,
        hospit_id: this.selectedHospit.id,
        is_hospit: 1,
        is_exclu: p.is_exclu || 0,
        is_factured: false,
      };
    });

    const doSubmit = (finalDatas: any[], montantDepassement: number = 0) => {
      const totalMontant = finalDatas.reduce((s, d) => s + (d.montant || 0), 0);
      const totalPartAssurance = finalDatas.reduce((s, d) => s + (d.part_assurance || 0), 0);
      const totalPartPatient = finalDatas.reduce((s, d) => s + (d.part_patient || 0), 0);

      const dataSinistre = {
        filiale_id: this.user.filiale_id,
        beneficiaire_id: this.selectedHospit.beneficiaire_id,
        prestataire_id: this.user.prestataire_id,
        matricule: this.selectedHospit.matricule,
        police_id: this.selectedHospit.police_id,
        college_id: this.selectedHospit.college_id,
        souscripteur_id: this.selectedHospit.souscripteur_id,
        garant_id: this.selectedHospit.garant_id,
        garantie_id: prescs[0].garantie_id || this.selectedHospit.garantie_id,
        exercice_id: this.selectedHospit.exercice_id,
        taux_applicable: this.itemBeneficiaireHospit?.taux_applicable ?? this.selectedHospit.taux_applicable,
        taux_couverture: this.itemBeneficiaireHospit?.taux_couverture ?? this.selectedHospit.taux_couverture,
        montant: totalMontant, part_patient: totalPartPatient, part_assurance: totalPartAssurance,
        depassement: montantDepassement,
        statut: 'ENCOURS_HOSPIT',
        hospit_id: this.selectedHospit.id,
        is_hospit: 1,
      };

      this.restClient.post('prestationActe/create', {
        montant: totalMontant, part_patient: totalPartPatient, part_assurance: totalPartAssurance,
        dataSinistre, datas: finalDatas,
      }).subscribe({
        next: (res: any) => {
          if (res && !res['hasError']) {
            prescs.forEach(p => { p.is_executed = true; });
            this.selectedPrescIds.clear();
            this.selectedPrescIds = new Set(this.selectedPrescIds);
            this.utilities.showSweetNotification(res['status']['message'], 'succes');
          } else {
            this.utilities.showSweetNotification(res?.['status']?.['message'] || 'Erreur', 'error');
          }
        },
        error: (err: any) => { this.utilities.showSweetNotification(err, 'error'); },
      });
    };

    const confirmerEtSoumettre = (finalDatas: any[], depassementMsg?: string, montantDepassement: number = 0) => {
      const totalMontant = finalDatas.reduce((s, d) => s + (d.montant || 0), 0);
      const totalPA = finalDatas.reduce((s, d) => s + (d.part_assurance || 0), 0);
      const totalPP = finalDatas.reduce((s, d) => s + (d.part_patient || 0), 0);
      const fmt = (n: number) => Math.round(n).toLocaleString('fr-FR');

      const depRow = montantDepassement > 0
        ? `<tr style="background:#fff3cd;">
             <td style="padding:6px 10px;text-align:left;color:#7a5800;">Dépassement</td>
             <td style="padding:6px 10px;text-align:right;font-weight:600;color:#7a5800;">${fmt(montantDepassement)} FCFA</td>
           </tr>`
        : '';

      const partsHtml = `
        <table style="width:100%;border-collapse:collapse;margin-top:10px;font-size:0.9em;">
          <tr style="background:#f0f4f8;">
            <td style="padding:6px 10px;text-align:left;">Prestations</td>
            <td style="padding:6px 10px;text-align:right;font-weight:600;">${prescs.length}</td>
          </tr>
          <tr>
            <td style="padding:6px 10px;text-align:left;">Montant total</td>
            <td style="padding:6px 10px;text-align:right;font-weight:600;">${fmt(totalMontant)} FCFA</td>
          </tr>
          <tr style="background:#f0f4f8;">
            <td style="padding:6px 10px;text-align:left;color:#0665aa;">Part assurance</td>
            <td style="padding:6px 10px;text-align:right;font-weight:600;color:#0665aa;">${fmt(totalPA)} FCFA</td>
          </tr>
          <tr>
            <td style="padding:6px 10px;text-align:left;color:#e67e22;">Part patient</td>
            <td style="padding:6px 10px;text-align:right;font-weight:600;color:#e67e22;">${fmt(totalPP)} FCFA</td>
          </tr>
          ${depRow}
        </table>`;

      const depHtml = depassementMsg
        ? `<div style="margin-top:10px;padding:8px 12px;background:#fff3cd;border-left:4px solid #ffc107;border-radius:4px;text-align:left;font-size:0.8em;color:#7a5800;">
             <i class="fa fa-exclamation-triangle" style="margin-right:6px;"></i>${depassementMsg}
           </div>`
        : '';

      Swal.fire({
        title: 'Exécution des prestations',
        html: partsHtml + depHtml,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#0665aa',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Confirmer',
        cancelButtonText: 'Annuler',
      }).then(result => {
        if (!result.value) return;
        doSubmit(finalDatas, montantDepassement);
      });
    };

    // Vérifier plafond PHARMA EN PREMIER — ajustement silencieux (patient règle à la sortie)
    const pharmaItems = datas.filter(d => {
      const p = prescs.find(pr => pr.id === d.prescription_acte_id);
      return p?.garantie_codification === 'PHARMA';
    });

    if (pharmaItems.length) {
      const totalPharmaPA = pharmaItems.reduce((s, d) => s + (d.part_assurance || 0), 0);
      const totalPharmaPP = pharmaItems.reduce((s, d) => s + (d.part_patient || 0), 0);
      this.restClient.post('bareme/deepSeekPharmacie', {
        index: 0, size: 1000,
        data: { part_assurance: totalPharmaPA, part_patient: totalPharmaPP, matricule: this.selectedHospit.matricule },
      }).subscribe({
        next: (res: any) => {
          let depassementMsg: string | undefined;
          let montantDepassement = 0;
          if (res && !res['hasError'] && res['item']?.montant_depassement > 0) {
            const dep = res['item'];
            depassementMsg = dep.message_depassement;
            montantDepassement = dep.montant_depassement;
            // Ajuster silencieusement les parts PHARMA
            const ratio = totalPharmaPA > 0 ? dep.part_assurance / totalPharmaPA : 0;
            datas.forEach(d => {
              const p = prescs.find(pr => pr.id === d.prescription_acte_id);
              if (p?.garantie_codification === 'PHARMA') {
                d.part_assurance = Math.round(d.part_assurance * ratio);
                d.part_patient = d.montant - d.part_assurance;
              }
            });
          }
          confirmerEtSoumettre(datas, depassementMsg, montantDepassement);
        },
        error: () => confirmerEtSoumettre(datas),
      });
    } else {
      confirmerEtSoumettre(datas);
    }
  }

  openActeModal(item: any) {
    this.selectedHospit = { ...item };
    this.itemActe = {};
    this.itemsPraticien = [];
    this.showActeModal = true;
    document.body.style.overflow = 'hidden';
  }

  closeActeModal() {
    this.showActeModal = false;
    document.body.style.overflow = '';
  }

  saveActe() {
    if (!this.itemActe.acte_id || !this.itemActe.medecin_id) {
      this.utilities.showSweetNotification(
        "Veuillez renseigner l'acte et le médecin",
        'error',
      );
      return;
    }
    const acte = this.itemsActe.find(
      (a: any) => a.id === this.itemActe.acte_id,
    );
    const dataSinistre = {
      filiale_id: this.user.filiale_id,
      beneficiaire_id: this.selectedHospit.beneficiaire_id,
      prestataire_id: this.user.prestataire_id,
      matricule: this.selectedHospit.matricule,
      montant: this.itemActe.montant,
      part_patient: this.itemActe.part_patient,
      part_assurance: this.itemActe.part_assurance,
      depassement: this.itemActe.depassement || 0,
      statut: this.selectedHospit.type_hospitalisation_codification === 'HM' ? 'ENCOURS_HOSPIT' : 'ATTENTE_PREVALIDATION_PRESTATAIRE',
      hospit_id: this.selectedHospit.id,
      is_hospit: 1,
    };
    let payload = {
      dataSinistre,
      datas: [
        {
          acte_id: this.itemActe.acte_id,
          medecin_id: this.itemActe.medecin_id,
          libelle: acte?.libelle,
          montant: this.itemActe.montant,
          part_patient: this.itemActe.part_patient,
          part_assurance: this.itemActe.part_assurance,
          beneficiaire_id: this.selectedHospit.beneficiaire_id,
          matricule: this.selectedHospit.matricule,
          prestataire_id: this.user.prestataire_id,
          demande_hospitalisation_id: this.selectedHospit.id,
          is_hospit: true,
          is_factured: false,
          quantite: 1,
        },
      ],
    };
    this.restClient.post('prestationActe/create', payload).subscribe({
      next: (res: any) => {
        if (res && !res['hasError']) {
          this.utilities.showSweetNotification(res['status']['message'], 'succes');
          this.closeActeModal();
        } else {
          this.utilities.showSweetNotification(res['status']['message'], 'error');
        }
      },
      error: (err: any) => { this.utilities.showSweetNotification(err, 'error'); },
    });
  }

  openDecompteModal(item: any) {
    this.selectedHospit = { ...item };
    this.itemsSinistreHospit = [];
    this.totalMontantSinistres = 0;
    this.totalPartAssuranceSinistres = 0;
    this.totalPartPatientSinistres = 0;
    this.totalDepassementSinistres = 0;
    this.showDecompteDetail = false;
    this.showDecompteModal = true;
    document.body.style.overflow = 'hidden';
    this.loadSinistresHospit(item);
  }

  closeDecompteModal() {
    this.showDecompteModal = false;
    document.body.style.overflow = '';
  }

  openFinHospitModal(item: any) {
    this.selectedHospit = { ...item };
    this.itemsSinistreHospit = [];
    this.totalMontantSinistres = 0;
    this.totalPartAssuranceSinistres = 0;
    this.totalPartPatientSinistres = 0;
    this.showFinHospitModal = true;
    document.body.style.overflow = 'hidden';
    this.loadSinistresHospit(item);
  }

  closeFinHospitModal() {
    this.showFinHospitModal = false;
    document.body.style.overflow = '';
  }

  private loadSinistresHospit(item: any) {
    this.isLoadingSinistres = true;
    this.restClient.post('sinistre/getByCriteria', {
      user_id: this.user.id,
      filiale_id: this.user.filiale_id,
      index: 0,
      size: 1000,
      data: { hospit_id: item.id },
    }).subscribe({
      next: (res: any) => {
        this.isLoadingSinistres = false;
        if (res && !res['hasError'] && res['items']) {
          this.itemsSinistreHospit = res['items'];
          this.totalMontantSinistres = this.itemsSinistreHospit.reduce((s: number, x: any) => s + (parseFloat(x.montant_remboursable) || 0), 0);
          this.totalPartAssuranceSinistres = this.itemsSinistreHospit.reduce((s: number, x: any) => s + (parseFloat(x.part_assurance) || 0), 0);
          this.totalPartPatientSinistres = this.itemsSinistreHospit.reduce((s: number, x: any) => s + (parseFloat(x.part_patient) || 0), 0);
          this.totalDepassementSinistres = this.itemsSinistreHospit.reduce((s: number, x: any) => s + (parseFloat(x.depassement) || 0), 0);
        } else {
          this.itemsSinistreHospit = [];
        }
      },
      error: () => { this.isLoadingSinistres = false; this.itemsSinistreHospit = []; },
    });
  }

  toggleSinistreDetail(s: any) {
    s._expanded = !s._expanded;
    if (s._expanded && !s._prestations) {
      s._loadingDetail = true;
      this.restClient.post('prestationActe/getByCriteria', {
        user_id: this.user.id,
        filiale_id: this.user.filiale_id,
        index: 0, size: 1000,
        data: { sinistre_id: s.id },
      }).subscribe({
        next: (res: any) => {
          s._loadingDetail = false;
          s._prestations = res?.['items'] ?? [];
        },
        error: () => { s._loadingDetail = false; s._prestations = []; },
      });
    }
  }

  envoyerEnPrevalidation() {
    const sinistresEncours = this.itemsSinistreHospit.filter((s: any) => s.statut === 'ENCOURS_HOSPIT');
    if (!sinistresEncours.length) {
      this.utilities.showSweetNotification('Aucun sinistre en cours à envoyer', 'error');
      return;
    }
    Swal.fire({
      title: 'Clôturer l\'hospitalisation',
      text: `Envoyer ${sinistresEncours.length} sinistre(s) en prévalidation et clôturer l'hospitalisation ?`,
      icon: 'question',
      showCancelButton: true,
      confirmButtonColor: '#0665aa',
      cancelButtonColor: '#6c757d',
      confirmButtonText: 'Oui, clôturer',
      cancelButtonText: 'Annuler',
    }).then((result) => {
      if (!result.value) return;

      const now = new Date().toISOString();
      const datasUpdate = sinistresEncours.map((s: any) => ({ id: s.id, statut: 'ATTENTE_PREVALIDATION_PRESTATAIRE' }));

      this.restClient.post('sinistre/update', {
        user_id: this.user.id,
        filiale_id: this.user.filiale_id,
        datas: datasUpdate,
      }).subscribe({
        next: (res: any) => {
          if (!res || res['hasError']) {
            this.utilities.showSweetNotification(res?.['status']?.['message'] || 'Erreur mise à jour sinistres', 'error');
            return;
          }
          // Poser date_sortie sur la prescription
          this.restClient.post('prescriptionActe/update', {
            user_id: this.user.id,
            filiale_id: this.user.filiale_id,
            datas: [{ id: this.selectedHospit.id, date_sortie: now }],
          }).subscribe({
            next: (res2: any) => {
              if (res2 && !res2['hasError']) {
                this.selectedHospit.date_sortie = now;
                // Mettre à jour localement les statuts des sinistres
                sinistresEncours.forEach((s: any) => { s.statut = 'ATTENTE_PREVALIDATION_PRESTATAIRE'; });
                this.utilities.showSweetNotification('Hospitalisation clôturée et sinistres envoyés en prévalidation', 'succes');
                this.closeFinHospitModal();
                this.getItemsDemandeHospitalisationActive();
              } else {
                this.utilities.showSweetNotification(res2?.['status']?.['message'] || 'Erreur mise à jour prescription', 'error');
              }
            },
            error: (err: any) => { this.utilities.showSweetNotification(err, 'error'); },
          });
        },
        error: (err: any) => { this.utilities.showSweetNotification(err, 'error'); },
      });
    });
  }

  openProrogationModal(item: any) {
    this.selectedHospit = { ...item };
    this.itemProrogation = { demande_hospitalisation_id: item.id };
    this.showProrogationModal = true;
    document.body.style.overflow = 'hidden';
  }

  closeProrogationModal() {
    this.showProrogationModal = false;
    document.body.style.overflow = '';
  }

  saveProrogation() {
    if (
      !this.itemProrogation.nb_jours ||
      !this.itemProrogation.affection_id ||
      !this.itemProrogation.raison
    ) {
      this.utilities.showSweetNotification(
        'Veuillez renseigner tous les champs obligatoires',
        'error',
      );
      return;
    }
    let payload = {
      data: {
        ...this.itemProrogation,
        prestataire_id: this.user.prestataire_id,
      },
    };
    this.restClient
      .post('demandeProrogationHospitalisation/create', payload)
      .subscribe({
        next: (res: any) => {
          if (res && !res['hasError']) {
            this.utilities.showSweetNotification(res['status']['message'], 'succes');
            this.closeProrogationModal();
          } else {
            this.utilities.showSweetNotification(res['status']['message'], 'error');
          }
        },
        error: (err: any) => { this.utilities.showSweetNotification(err, 'error'); },
      });
  }

  demarrerHospit(item: any) {
    // HC : démarrage bloqué avant la date d'intervention
    if (item.type_hospitalisation_codification === 'HC' && item.date_intervention) {
      const dateIntervention = new Date(item.date_intervention);
      dateIntervention.setHours(0, 0, 0, 0);
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      if (today < dateIntervention) {
        this.utilities.showSweetNotification(
          `Démarrage impossible : la date d'intervention est le ${dateIntervention.toLocaleDateString('fr-FR')}`,
          'error'
        );
        return;
      }
    }

    Swal.fire({
      title: 'Démarrer l\'hospitalisation',
      text: 'Confirmer le démarrage de l\'hospitalisation ?',
      icon: 'question',
      showCancelButton: true,
      confirmButtonColor: '#0665aa',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Oui, démarrer',
      cancelButtonText: 'Annuler',
    }).then((result) => {
      if (!result.value) return;

      if (item.type_hospitalisation_codification === 'HC') {
        this.demarrerHospitHC(item);
      } else {
        this.setDateDemarrage(item);
      }
    });
  }

  private demarrerHospitHC(item: any) {
    // 1. Charger la proforma validée
    this.restClient.post('proformaHospitalisation/getByCriteria', {
      user_id: this.user.id,
      filiale_id: this.user.filiale_id,
      index: 0,
      size: 10,
      data: { prescription_acte_id: item.id },
    }).subscribe({
      next: (res: any) => {
        if (!res || res['hasError'] || !res['items']?.length) {
          this.utilities.showSweetNotification('Proforma introuvable pour cette hospitalisation', 'error');
          return;
        }
        const proforma = res['items'][0];
        const details: any[] = proforma.details || [];
        if (!details.length) {
          this.utilities.showSweetNotification('Aucun détail de proforma trouvé', 'error');
          return;
        }

        const taux = parseFloat(item.taux_applicable) || 0;
        const montantTotal = parseFloat(proforma.montant_accord) || 0;
        const partAssurance = (taux / 100) * montantTotal;
        const partPatient = montantTotal - partAssurance;

        const datas = details.map((d: any) => ({
          prescription_acte_id: item.id,
          libelle: d.libelle,
          quantite: d.quantite_accord ?? d.quantite ?? 1,
          quantite_accord: d.quantite_accord ?? d.quantite ?? 1,
          prix_unitaire: d.montant_accord ?? d.total ?? 0,
          prix_unitaire_accord: d.montant_accord ?? d.total ?? 0,
          montant: d.montant_accord ?? d.total ?? 0,
          montant_remboursable: d.montant_accord ?? d.total ?? 0,
          part_assurance: ((taux / 100) * (parseFloat(d.montant_accord) || 0)),
          part_assurance_net: ((taux / 100) * (parseFloat(d.montant_accord) || 0)),
          part_patient: (((100 - taux) / 100) * (parseFloat(d.montant_accord) || 0)),
          part_patient_net: (((100 - taux) / 100) * (parseFloat(d.montant_accord) || 0)),
          depassement: 0,
          beneficiaire_id: item.beneficiaire_id,
          matricule: item.matricule,
          matricule_assure: item.matricule_assure,
          prestataire_id: this.user.prestataire_id,
          is_hospit: true,
          is_factured: false,
          hospit_id: item.id,
          proforma_id: proforma.id,
        }));

        const dataSinistre = {
          filiale_id: this.user.filiale_id,
          beneficiaire_id: item.beneficiaire_id,
          prestataire_id: this.user.prestataire_id,
          matricule: item.matricule,
          police_id: item.police_id,
          college_id: item.college_id,
          souscripteur_id: item.souscripteur_id,
          garant_id: item.garant_id,
          garantie_id: item.garantie_id,
          exercice_id: item.exercice_id,
          taux_applicable: item.taux_applicable,
          taux_couverture: item.taux_couverture,
          montant: montantTotal,
          part_patient: partPatient,
          part_assurance: partAssurance,
          depassement: 0,
          statut: 'ATTENTE_PREVALIDATION_PRESTATAIRE',
          hospit_id: item.id,        // lien vers PrescriptionActe hospit initial
          proforma_id: proforma.id,  // lien vers la proforma validée
          is_hospit: 1,
        };

        // 2. Créer sinistre + prestationActe
        this.restClient.post('prestationActe/create', {
          montant: montantTotal,
          part_patient: partPatient,
          part_assurance: partAssurance,
          dataSinistre,
          datas,
        }).subscribe({
          next: (res2: any) => {
            if (!res2 || res2['hasError']) {
              this.utilities.showSweetNotification(res2?.['status']?.['message'] || 'Erreur création prestation', 'error');
              return;
            }
            // 3. Poser date_demarrage
            this.setDateDemarrage(item);
          },
          error: (err: any) => { this.utilities.showSweetNotification(err, 'error'); },
        });
      },
      error: (err: any) => { this.utilities.showSweetNotification(err, 'error'); },
    });
  }

  private setDateDemarrage(item: any) {
    const now = new Date().toISOString();
    this.restClient.post('prescriptionActe/update', {
      user_id: this.user.id,
      filiale_id: this.user.filiale_id,
      datas: [{ id: item.id, date_demarrage: now }],
    }).subscribe({
      next: (res: any) => {
        if (res && !res['hasError']) {
          item.date_demarrage = now;
          this.utilities.showSweetNotification(res['status']['message'], 'succes');
        } else {
          this.utilities.showSweetNotification(res['status']['message'], 'error');
        }
      },
      error: (err: any) => { this.utilities.showSweetNotification(err, 'error'); },
    });
  }

  canProroge(item: any): boolean {
    if (!item.date_sortie_previsionnelle) return false;
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const dateSortie = new Date(item.date_sortie_previsionnelle);
    dateSortie.setHours(0, 0, 0, 0);
    return today >= dateSortie;
  }

  annulerHospit(item: any) {
    Swal.fire({
      title: 'Annuler l\'hospitalisation',
      text: 'Confirmer l\'annulation de cette hospitalisation ?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#d33',
      cancelButtonColor: '#6c757d',
      confirmButtonText: 'Oui, annuler',
      cancelButtonText: 'Retour',
    }).then((result) => {
      if (!result.value) return;
      this.restClient.post('prescriptionActe/update', {
        user_id: this.user.id,
        filiale_id: this.user.filiale_id,
        datas: [{ id: item.id, is_annule: 1 }],
      }).subscribe({
        next: (res: any) => {
          if (res && !res['hasError']) {
            item.is_annule = 1;
            this.utilities.showSweetNotification(res['status']['message'], 'succes');
          } else {
            this.utilities.showSweetNotification(res['status']['message'], 'error');
          }
        },
        error: (err: any) => { this.utilities.showSweetNotification(err, 'error'); },
      });
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    console.log('changes: ', changes);
    if (changes['itemBeneficiare'] && changes['itemBeneficiare'].currentValue) {
      console.log("changes['itemBeneficiare']: ", changes['itemBeneficiare']);
      this.itemBeneficiare = changes['itemBeneficiare'].currentValue;
      this.getItemsDemandeHospitalisationActive();
    }
  }

  onSelectMedoc(event: any) {
    console.log('current medoc', event);
    this.selectedItem = event || {};
  }
  onSelectMedocPro(event: any) {
    console.log('current medoc', event);
    this.selectedItem = event || {};
    // getTarifActe()
    this.itemToAdd.quantite = 1;
    // this.onAddItemToList()
  }

  goNext() {
    this.onGoToTab.emit('pharmacie');
  }

  removeItem(index: number): void {
    if (confirm('Êtes-vous sûr de vouloir supprimer cet élément?')) {
      this.itemsElement.splice(index, 1);
    }
  }

  onSetUserInfo(event: any) {
    if (event.id) {
      this.itemBeneficiare = event;
      this.authService.setActiveBeneficiaire(event);
      this.itemConsultation = {};
      this.beneficiaireAutOselect = this.itemBeneficiare;
      this.getItemsDemandeHospitalisationActive();
    } else {
      this.authService.setActiveBeneficiaire({});
      this.beneficiaireAutOselect = {};
    }
  }

  onPageChange(event: PageEvent) {
    this.index = event.pageIndex;
    this.size = event.pageSize;
    this.getItemsDemandeHospitalisationActive();
  }

  search() {
    this.index = 0;
    this.getItemsDemandeHospitalisationActive();
  }
}
